import { apiClient } from '@/utils/api-client';
import type { ApiResponse, JsonApiResource } from '@/types/api';

export interface Prompt {
  id: string;
  key: string;
  published_value: string | null;
  pending_value: string | null;
  published_at: string | null;
  label: string;
  description: string | null;
  has_pending_changes: boolean;
  created_at: string;
  updated_at: string;
}

export const promptService = {
  async list(): Promise<ApiResponse<JsonApiResource<Prompt>[]>> {
    return apiClient.get('/api/admin/prompts');
  },

  async get(id: string): Promise<ApiResponse<JsonApiResource<Prompt>>> {
    return apiClient.get(`/api/admin/prompts/${id}`);
  },

  async update(id: string, pendingValue: string): Promise<ApiResponse<JsonApiResource<Prompt>>> {
    return apiClient.patch(`/api/admin/prompts/${id}`, {
      prompt: { pending_value: pendingValue },
    });
  },

  async publish(id: string): Promise<ApiResponse<JsonApiResource<Prompt>>> {
    return apiClient.post(`/api/admin/prompts/${id}/publish`);
  },

  async discard(id: string): Promise<ApiResponse<JsonApiResource<Prompt>>> {
    return apiClient.post(`/api/admin/prompts/${id}/discard`);
  },

  async publishAll(): Promise<ApiResponse<JsonApiResource<Prompt>[]>> {
    return apiClient.post('/api/admin/prompts/publish_all');
  },
};
